import { dialogues as soldierDialogues } from './soldier';
import { h01HostDialogue, h01CompleteDialogue } from './raadhustorvet';
import type { DialogueDefinition } from '../../domain/types';

export const dialogues: Record<string, DialogueDefinition> = {
  ...soldierDialogues,
  [h01HostDialogue.id]: h01HostDialogue,
  [h01CompleteDialogue.id]: h01CompleteDialogue,
};
